<template>
    <div class="customer-feedbacks-content">
        <div class="table-header">
            <div class="respondents-header">
                <p>RESPONDENTS</p>
            </div>
            <div class="rating-header">
                <p>RATING</p>
            </div>
            <div class="date-header">
                <p>DATE</p>
            </div>
            <div class="inquiry-resolved-header">
                <p>INQUIRY RESOLVED</p>
            </div>
            <div class="feedback-header">
                <p>FEEDBACK</p>
            </div>
        </div>
        <div v-if="Array.isArray(customerFeedbackData.content)">
            <NoResultsFound v-if="customerFeedbackData.content.length <= 0" class="no-result-content"/>
            <div v-else>
                <div v-for="feedback in customerFeedbackData.content" :key="feedback.id" class="table-content">
                    <div class="respondents-content">
                        <img src="../../assets/channel-icon/facebook.svg" v-if="feedback.channel.toLowerCase() ==='facebook'" alt="facebook icon">
                        <img src="../../assets/channel-icon/line.svg" v-else-if = "feedback.channel.toLowerCase() ==='line'" alt="line icon">
                        <img src="../../assets/channel-icon/microsoft-team.png" v-else-if = "feedback.channel.toLowerCase() ==='msteams'" alt="msteam icon">
                        <img src="../../assets/images/ada_logo.png" v-else-if ="feedback.channel.toLowerCase() ==='ada'" alt="ada icon">
                        <img src="../../assets/images/user_placeholder.png" v-else alt="avatar icon">
                        <div>
                            <p>{{feedback.username}}</p>
                            <p class="text-email">{{ feedback.email }}</p>
                        </div>
                    </div>
                    <div class="rating-content">
                        <div class="score-star-container d-flex">
                            <div v-for="score in feedback.score" :key="'full'+score" class="full-star">
                                <i class="bx bxs-star"></i>
                            </div>
                            <div v-for="score in totalEmptyStar(feedback.score)" :key="'empty'+score" class="empty-star">
                                <i class="bx bxs-star"></i>
                            </div>
                        </div>
                        <p>({{feedback.score}})</p>
                    </div>
                    <div class="date-content">
                        <p>{{dateFormatter(feedback.updated_at)}}</p>
                    </div>
                    <div class="inquiry-resolved-content">
                        <p>{{ resolveFormater(feedback.resolution_type)}}</p>
                    </div>
                    <div class="feedback-content">
                        <p>{{isEmptyString(feedback.comment) ? 'N/A': feedback.comment}}</p>
                        <div class="preset-wrapper">
                            <div v-for="preset in feedback.preset_comment" :key="'preset'+preset" class="preset-badge">
                                <p>{{ preset }}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="footer-content">
                    <div>
                        <p>Showing {{ startItemOfEachPage }} to {{ endItemOfEachPage }} of {{ customerFeedbackData.totalElements }} results</p>
                    </div>
                    <div class="pagination-content">
                        <bootstrap-pagination
                        v-model="currentPage"
                        :total-rows="customerFeedbackData.totalElements"
                        :per-page="customerFeedbackData.size"
                        :hide-goto-end-buttons="true"
                        aria-controls="my-table"
                        @change="onClickPagination($event)"
                        class="b-pagination-container"
                        >
                        <template #prev-text>
                            <div class="pagaination-option" :class="{'disable-page': customerFeedbackData.first}">
                                <p>Previous</p>
                            </div>
                        </template>
                        <template #next-text>
                            <div class="pagaination-option" :class="{'disable-page': customerFeedbackData.last}">
                                <p>Next</p>
                            </div>
                        </template>
                        <template #ellipsis-text >
                            <div class="pagaination-option">
                                <p>...</p>
                            </div>
                        </template>
                        <template #page="{ page, active }">
                            <div v-if="active" class="pagaination-option current-page">
                                <p>{{ page }}</p>
                            </div>
                            <div v-else class="pagaination-option">
                                <p>{{ page }}</p>
                            </div>
                        </template>
                        </bootstrap-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { DateTime } from 'luxon';
import { BPagination } from 'bootstrap-vue';
import NoResultsFound from '../NoResultsFound.vue';

export default {
  name: 'CustomerFeedbacksWidget',
  components: {
    'bootstrap-pagination': BPagination,
    NoResultsFound
  },
  props: {
    customerFeedbackData: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      currentPage: this.customerFeedbackData.pageable.pageNumber + 1,
    };
  },
  methods: {
    dateFormatter(date) {
      return DateTime.fromISO(date).setZone('Asia/Bangkok').toFormat('dd/LL/yyyy');
    },
    totalEmptyStar(feedbackScore) {
      return 4 - feedbackScore;
    },
    onClickPagination(page) {
      this.$emit('selected-page', page - 1);
    },
    isEmptyString(value) {
      return typeof value !== 'string' || value.trim().length <= 0;
    },
    resolveFormater(resolveType) {
      if (resolveType === 'YES') { return 'Yes'; }
      return 'No';
    },
  },
  computed: {
    startItemOfEachPage() {
      return (this.customerFeedbackData.pageable.pageSize * this.customerFeedbackData.pageable.pageNumber) + 1;
    },
    endItemOfEachPage() {
      if (this.customerFeedbackData.last) {
        return this.customerFeedbackData.totalElements;
      }
      return (this.customerFeedbackData.pageable.pageNumber + 1) * this.customerFeedbackData.pageable.pageSize;
    }
  },
  watch: {
    customerFeedbackData(val) {
      this.customerFeedbackData = val;
    },
  },
};
</script>
<style lang="scss">
.customer-feedbacks-content{
    .table-header{
        background-color: #F5F6FA;
        display: grid;
        grid-template-columns: repeat(8, minmax(0, 1fr));
        gap: 16px;
        padding: 12px 16px;
        p {
            color: #0D173C;
            font-size: 13px;
            font-weight: 500;
            line-height: 19.5px;
            text-align: left;
            margin-top: auto;
            margin-bottom: auto;
        }
        .respondents-header{
            grid-column: span 2 / span 2;
        }
        .rating-header{
            grid-column: span 1 / span 1;
        }
        .date-header{
            grid-column: span 1 / span 1;
        }
        .inquiry-resolved-header{
            grid-column: span 1 / span 1;
        }
        .feedback-header{
            grid-column: span 3 / span 3;
        }
    }
    .table-content{
        display: grid;
        grid-template-columns: repeat(8, minmax(0, 1fr));
        gap: 16px;
        padding: 12px 16px;
        border-bottom: 1px solid #E7E8EE;
        p {
            font-size: 14px;
            font-weight: 400;
            line-height: 21px;
            text-align: left;
            color: #4B5178;
        }
        .respondents-content{
            grid-column: span 2 / span 2;
            display: flex;
            img {
                width: 16px;
                height: 16px;
                margin-right: 8px;
                margin-top: 2px;
            }
            p {
                margin-bottom: 0px;
                font-size: 14px;
                font-weight: 500;
                line-height: 21px;
                text-align: left;
                color: #4B5178;
            }
            .text-email{
                color: #868BA6;
                font-size: 12px;
                font-weight: 400;
                line-height: 18px;
            }
        }
        .rating-content{
            grid-column: span 1 / span 1;
            display: flex;
            p {
                margin: 0;
            }
            .score-star-container{
                font-size: 16px;
                padding-right: 4px;
                .full-star {
                    color: #FCD14E;
                }
                .empty-star{
                    color: #E7E8EE;
                }
            }
        }
        .date-content{
            grid-column: span 1 / span 1;
            display: flex;
            p {
                margin: 0;
            }
        }
        .inquiry-resolved-content{
            grid-column: span 1 / span 1;
            display: flex;
            p {
                margin: 0;
            }
        }
        .feedback-content{
            grid-column: span 3 / span 3;
            .preset-wrapper{
                display: flex;
                gap: 4px;
                flex-wrap: wrap;
                .preset-badge{
                    border: 1px solid #E7E8EE;
                    border-radius: 64px;
                    padding: 0px 8px;
                    p {
                        margin: 0;
                        font-size: 10.5px;
                        font-weight: 400;
                        color: #646A8C;
                    }
                }
            }
            .resolved-content {
                grid-column: span 1 / span 1;
            }
        }
    }
    .footer-content{
        display: flex;
        justify-content: space-between;
        padding: 20px 14px;
        p{
            font-size: 14px;
            font-weight: 400;
            line-height: 19.1px;
            text-align: left;
            color: #878A99;
        }
        .pagination-content{
            display: flex;
            align-items: center;
            .pagaination-option{
                font-size: 14px;
                font-weight: 400;
            }
            .pagaination-option.disable-page{
                cursor: not-allowed;
                color: #878A99;
            }
            .pagaination-option.current-page{
                p{
                  color:white;
                }
            }
            .b-pagination-container{
                p{
                  margin-bottom: 0px;
                  color: #3D78E3;
                }
                .page-item .page-link{
                    border: 1px solid #E9EBEC;
                }
                .page-item.active .page-link{
                    border: 1px solid #3D78E3;
                    background-color: #3D78E3;
                }
                .page-item.disabled .page-link{
                    p{
                        color: #878A99;
                    }
                }
            }
        }
    }
    .no-result-content{
        margin-top: 97px;
        margin-bottom: 97px;
    }
}
</style>
